import React, { Component } from 'react';
import Hit from "./hit"
class HitsList extends Component {
        constructor(props) {
            super(props);
            this.state = {};
            this.renderImage = this.renderImage.bind(this);
        }
         renderImage = (hit, colour) => {

            if (hit.thumbnails && Object.keys(hit.thumbnails).length) {
                if (!colour) {
                    return hit.thumbnails[Object.keys(hit.thumbnails)[0]];
                }
                return hit.thumbnails[findMatch(colour, Object.keys(hit.thumbnails))];
            }
            return <div className="thumbnail__placeholder" />
        }

         render() {
             const { hit } = this.props;
                    return  <div>
                                    <Hit
                                        key={hit.objectID}
                                        title={hit.title}
                                        image={Object.keys(hit.thumbnails || {}).length && hit.thumbnails 
                                            ? this.renderImage(hit, null)
                                            : null}
                                        absoluteUri={hit.absoluteUri}
                                    />
                            </div>;
                }
}
export default HitsList